"use strict";
/* globals module */
/**
 * @module baasicArticleTagsDefinition
 * @description  Article Tags Definition provides an easy way to consume  Article Tags REST API end-points. `articleTagsDefinition` functions enable performing standard CRUD operations directly on article tag resources, whereas the `articleClient` functions allow management between article and article tag. In order to obtain needed routes `articleTagsDefinition` uses `articleTagsRoute`.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../httpApi");
var _1 = require("./");
var ArticleTagsClient = /** @class */ (function () {
    function ArticleTagsClient(articleTagsRoute, articleTagsSubscriptionsClient, apiClient) {
        this.articleTagsRoute = articleTagsRoute;
        this.articleTagsSubscriptionsClient = articleTagsSubscriptionsClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ArticleTagsClient.prototype, "routeDefinition", {
        get: function () {
            return this.articleTagsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleTagsClient.prototype, "subscriptions", {
        get: function () {
            return this.articleTagsSubscriptionsClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of article tag resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example articleTagsClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ArticleTagsClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified article tag resource.
     * @method
     * @param id Article tag id or slug that uniquely identifies article tag resource that needs to be retrieved.
     * @param options Options object that contains embed data.
     * @returns A promise that is resolved once the get action has been performed.
     * @example articleTagsClient.get('<articleTag-id>')
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                       // perform error handling here
                   });
    **/
    ArticleTagsClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.articleTagsRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the update article tag action has been performed; this action updates a tag. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleTagsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(articleTag);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An article tag object used to update specified article tag resource.
     * @returns A promise that is resolved once the update article tag action has been performed.
     * @example // articleTag is a resource previously fetched using get action.
                    articleTag.tag = '<new-tag>';
                    articleTagsClient.update(articleTag)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleTagsClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove article tag action has been performed. If the action is successfully completed, the article tag resource will be permanently removed from the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleTagsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(articleTag);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An article tag object used to delete specified article tag resource.
     * @returns A promise that is resolved once the remove article tag action has been performed.
     * @example // articleTag is a resource previously fetched using get action.
                    articleTagsClient.remove(articleTag)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleTagsClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    ArticleTagsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ArticleTagsRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.ArticleTagsSubscriptionsClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ArticleTagsRoute !== "undefined" && _1.ArticleTagsRoute) === "function" ? _a : Object, typeof (_b = typeof _1.ArticleTagsSubscriptionsClient !== "undefined" && _1.ArticleTagsSubscriptionsClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], ArticleTagsClient);
    return ArticleTagsClient;
}());
exports.ArticleTagsClient = ArticleTagsClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 
